<template>
	<div>
		<x-modal
			:wWidth="1080"
			v-if="isVisible"
			@cancel="requestPrivacyConsentModalClose"
			@close="requestPrivacyConsentModalClose"
			@ok="requestPrivacyConsentModalSubmit"
			:draggable="true"
			:resizable="true"
			:loading="loading"
			:okDisabled="requestPrivacyConsentModalButtonDisabled"
			okText="Request Consent"
		>
			<div slot="title" :class="`d-flex justify-content-between align-items-center`">
                Request Privacy Consent
            </div>

			<div class="container">
				<el-form label-width="140px">

					<email-sending-options></email-sending-options>

					<email-recipients
						v-if="emailBuilder.sendEmail || emailBuilder.sendSms"
						:recipientType="recipientTypes"
						:autoSelectType="recipientTypes"
						:recipientAllowCreate="false"
						:hideCC="!emailBuilder.sendEmail ? true : false"
						:hideBCC="!emailBuilder.sendEmail ? true : false"
					></email-recipients>

					<email-task v-model="emailBuilder.task"></email-task>

					<el-divider v-if="!_.isEmpty(emailBuilder.recipients) && (emailBuilder.sendEmail || emailBuilder.sendSms)"></el-divider>

					<email-markup-multi
						class="mb-3"
						v-if="!_.isEmpty(emailBuilder.recipients) && (emailBuilder.sendEmail || emailBuilder.sendSms)"
						:documents="true"
						action="request-privacy-consent"
					></email-markup-multi>
				</el-form>
			</div>
		</x-modal>
	</div>
</template>

<script>
    import EmailSendingOptions from "@ambition/components/messages/EmailSendingOptions.vue"
	import EmailRecipients from "@ambition/components/messages/EmailRecipients"
	import EmailAttachments from "@ambition/components/messages/EmailAttachments"
	import EmailMarkupMulti from "@ambition/components/messages/EmailMarkupMulti"
	import EmailTask from "@ambition/components/messages/EmailTask"
	import { mapGetters, mapState } from "vuex"

	export default {
		name: "BuilderRequestPrivacyConsentModal",
		props: {
			visible: {
				required: true,
				type: Boolean,
			},
			applicants: {
				required: true,
				type: Array,
			},
		},
		components: {
            EmailSendingOptions,
			EmailRecipients,
			EmailAttachments,
			EmailMarkupMulti,
			EmailTask,
		},
		watch: {
			visible() {
				this.isVisible = this.visible
			},
		},
		data() {
			return {
				isVisible: false,
				loading: false,
				recipientTypes: ["applicant"],
				applicantDocuments: [],
				submitModal: {
                visible: false,
            },

			}
		},
		mounted() {
        },
		activated() {},
		computed: {
			...mapGetters({
				emailBuilder: "builderEmail/getEmail",
                templatesLoaded: "builderEmail/checkTemplatesLoaded",
                documentsList: "application/documentsList"
			}),
			requestPrivacyConsentModalButtonDisabled() {
                if (!this.templatesLoaded) return true
				if (!this.emailBuilder.sendEmail && !this.emailBuilder.sendSms) return true
                if (this.emailBuilder.delaySending && !this.emailBuilder.sendAt) return true
				if (_.size(this.emailBuilder.recipients) >= 1 && !this.loading) return false
				return true
			},
		},

		methods: {
			requestPrivacyConsentModalOpen() {
				this.$store.dispatch("builderEmail/resetEmail")
				this.loading = false
				this.isVisible = true
			},

			requestPrivacyConsentModalClose() {
				this.$store.dispatch("builderEmail/resetEmail")
				this.loading = false
				this.isVisible = false
				this.$emit("update:visible", false)
			},

			storeDocumentsList: async function () {
				if (_.size(this.emailBuilder.recipients) > 0) {
					this.emailBuilder.recipients.forEach(recipient => {
						this.applicantDocuments.push({
							applicant_id: Number(_.get(recipient.id.split("-"), "1", recipient.id)),
							documents: recipient.template.documents
						})
					})
				}

				let tenantHeaders = {headers: {Authorization: "Bearer " + this.$store.getters.token}}
				let appId = this.$store.getters.appId
				let documents = []

				_.each(this.applicantDocuments, (applicantDocument) => {
					let applicant_id = applicantDocument.applicant_id
					let applDocs = applicantDocument.documents

					_.each(applDocs, (applDoc) => {

						let documentType = _.find(this.documentsList, (document) => {
							return document.id === applDoc;
						});

						if (documentType) {
							documents.push({
								applicant_id: applicant_id,
								document_type_id: documentType.id,
								name: documentType.displayName
							})
						}
					})
				})

				let body = {
					message: "Store Documents List",
					documents: documents
				}
				return axios
					.post("/api/v2/applications/" + appId + "/documents", body, tenantHeaders)
					.then(function (value) {
						return value
					})
					.catch(function (error) {
						console.error(error)
					})
			},

			requestPrivacyConsentModalSubmit() {
				this.loading = true
				if (this.emailBuilder.sendEmail || this.emailBuilder.sendSms) {
                    const header = {
                        headers: { Authorization: "Bearer " + this.$store.getters.token }
                    };
					axios
						.patch(
							`/api/v3/privacy-consent/${this.$store.getters.initAppData.id}`,
							{
								email: this.emailBuilder
							},
							header
						)
						.then((res) => {
							// create application task
							this.storeDocumentsList()

							if (_.get(this.emailBuilder, "task.create", false)) {
								this.$store.dispatch("statusIndicators/changeStatus", {
									stage: "createTask",
									token: this.$store.getters.token,
									remindMe: this.$moment(this.emailBuilder.task.remindMe).format("YYYY-MM-DD"),
									taskName: this.emailBuilder.task.name,
									time: this.emailBuilder.task.time,
									userId: this.emailBuilder.task.userId,
									appId: this.$store.getters.initAppData.id,
								})
							}

							// create recipient tasks
							if (_.get(this.emailBuilder, "recipients", false)) {
								this.emailBuilder.recipients.forEach((recipient) => {
									if (_.get(recipient, "template.task.create", false)) {
										this.$store.dispatch("statusIndicators/changeStatus", {
											stage: "createTask",
											token: this.$store.getters.token,
											remindMe: this.$moment(recipient.template.task.remindMe).format("YYYY-MM-DD"),
											taskName: recipient.template.task.name,
											time: recipient.template.task.time,
											userId: recipient.template.task.userId,
											appId: this.$store.getters.initAppData.id,
										})
									}
								})
							}

							swal({
								title: "Success",
								type: "success",
								text: "Privacy Consent Form Request Sent"
							})

							this.requestPrivacyConsentModalClose()
						})
						.catch((err) => {
							console.error(err)
							this.loading = false
							Message({
								message: "Request Failed",
								type: "error",
							})
						})
						.finally(() => {
							this.loading = false
						})
				}
			},
		},
	}
</script>
